import { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import useAuth from 'src/hooks/useAuth';

import { capitalizeFirstLetter } from 'src/utils/string';
import Dialog from 'src/componentes/dialog';
import MdiIcon from 'src/componentes/mdi-icon';
import Avatar from 'src/componentes/avatar';
import http from 'src/services/httpService';
import PerfilDossie from './PerfilDossie';

const DossieColaborador = ({ colaboradorId }) => {
  const intl = useIntl();
  const [isOpen, setIsOpen] = useState(true);
  const dossieRef = useRef();
  const { terms: resources } = useAuth();

  if (!isOpen) return null;

  const handleClose = () => {
    setIsOpen(false);
    dossieRef.current?.close();
  };

  return (
    <Dialog
      ref={dossieRef}
      padContent
      width="90%"
      maxHeight="95%"
      onClose={handleClose}
    >
      <div
        className="d-flex px-4 justify-content-between"
        style={{ fontSize: '1.5rem' }}
      >
        <span className="text-primary font-weight-bolder">
          {intl.formatMessage({ id: 'dossie' })}
        </span>
        <MdiIcon
          icon="cog"
          className="text-primary"
          size="24"
          style={{ cursor: 'pointer' }}
        />
      </div>
      <PerfilDossie colaboradorId={colaboradorId} />
    </Dialog>
  );
};

export default DossieColaborador;
